import authApiClient from '../interceptor.authApiClient';
import mainApiClient from '../interceptor.mainApiClient';

const userEndpoints = {
  getSignedInUser: (config) =>
    mainApiClient.get('/api/v1/User', config),
  recordLastLogin: (config) =>
    mainApiClient.post('/api/v1/User/last-login', null, config),
  getUserById: (id, config) =>
    mainApiClient.get(`/api/v1/User/${id}`, config),
  checkIfAlienExists: (config) =>
    mainApiClient.get('/api/v1/User/AlienCheck', config),
  getAllUsers: (page, pageSize, config) =>
    authApiClient.get(`/api/v1/user/all-users?page=${page}&pageSize=${pageSize}`, config),
  newUserCreation: (data, config) =>
    authApiClient.post('/api/v1/UserCreation', data, config),
  deactivateUser: (userId, data, config) =>
    authApiClient.put(`/api/v1/User/${userId}/deactivate`, data, config),
  deleteUser: (userId, config) =>
    authApiClient.delete(`/api/v1/User/${userId}`, config),
  updateUser: (userId, data, config) =>
    authApiClient.put(`/api/v1/User/${userId}`, data, config),
  changePassword: (data, config) =>
    authApiClient.post('/api/v1/user/change-password', data, config),
  getAllUserRoles: (config) =>
    mainApiClient.get('/api/v1/Roles/all-roles', config),
  updateUserRoles: (userId, roles, config) =>
    authApiClient.put(`/api/v1/User/${userId}/roles`, roles, config),
};

export default userEndpoints;
